<!-- Start: Rejwan: 19-05-2025 GF Summary -->
<template>
    <div>
        <div class="ibox col-md-12 border-0">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
                <h4 class="clearfix">
                    <span class="float-left">Gratuity Fund Contribution History for {{company_name}}
                        <span class="title-sub-text">Get a clear picture of your GF Contribution. Use this information to better understand your workforce.
                        </span>
                    </span>
                    <span class="float-right">
                    </span>
                </h4>
            </div>
            <div class="ibox-content pf-overview pl-0">
                <div class="">
                    <div class="payslip-details-info-inner row">
                        <div class="col-md-4 payslip-details-info-right">
                            <div class="wrapper d-flex pl-0">
                                <div class="col-md-6">
                                    <div class="first pt-2">Active Employees</div>
                                </div>
                                <div class="col-md-6 text-right px-0">
                                    <div class="second">
                                        <div class="second">
                                            {{ gf_summary.total_active_employees }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 payslip-details-info-right">
                            <div class="wrapper d-flex pl-0">
                                <div class="col-md-6">
                                    <div class="first pt-2">Total GF Eligible (as at {{current_date}})</div>
                                </div>
                                <div class="col-md-6 text-right px-0">
                                    <div class="second">
                                        <div class="second">
                                           {{ gf_summary.total_gf_eligibile }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 payslip-details-info-right">
                            <div class="wrapper d-flex pl-0">
                                <div class="col-md-6">
                                    <div class="first pt-2">Employee Awaiting Settlement</div>
                                </div>
                                <div class="col-md-6 text-right px-0">
                                    <div class="second">
                                        <div class="second">
                                            {{ gf_summary.total_employee_awaiting_settlement }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 payslip-details-info-right">
                            <div class="wrapper d-flex pl-0">
                                <div class="col-md-6">
                                    <div class="first pt-2">Total GF Payable (as at {{current_date}})</div>
                                </div>
                                <div class="col-md-6 text-right px-0">
                                    <div class="second">
                                        <div class="second">
                                            <span class="" style="font-size: 25px;">&#2547;</span>
                                            {{ formatMoney(gf_summary.total_gf_payable) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 payslip-details-info-right">
                            <div class="wrapper d-flex pl-0">
                                <div class="col-md-6">
                                    <div class="first pt-2">Total Fund Contribution</div>
                                </div>
                                <div class="col-md-6 text-right px-0">
                                    <div class="second">
                                        <div class="second">
                                            <span class="" style="font-size: 25px;">&#2547;</span>
                                            {{ formatMoney(gf_summary.total_fund_contribution) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 payslip-details-info-right">
                            <div class="wrapper d-flex pl-0">
                                <div class="col-md-6">
                                    <div class="first pt-2">Total Settlement Amount</div>
                                </div>
                                <div class="col-md-6 text-right px-0">
                                    <div class="second">
                                        <div class="second">
                                            <span class="" style="font-size: 25px;">&#2547;</span>
                                            {{ formatMoney(gf_summary.total_settlement_amount) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="col-md-4 payslip-details-info-right">
                            <div class="wrapper d-flex pl-0">
                                <div class="col-md-6">
                                    <div class="first pt-2">Total Reclaimed Amount</div>
                                </div>
                                <div class="col-md-6 text-right px-0">
                                    <div class="second">
                                        <div class="second">
                                            <span class="" style="font-size: 25px;">&#2547;</span>
                                            {{ formatMoney(gf_summary.total_reclaim_amount) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="col-md-4 payslip-details-info-right">
                            <div class="wrapper d-flex pl-0">
                                <div class="col-md-6">
                                    <div class="first pt-2">Net Contribution Balance</div>
                                </div>
                                <div class="col-md-6 text-right px-0">
                                    <div class="second">
                                        <div class="second">
                                            <span class="" style="font-size: 25px;">&#2547;</span>
                                            {{ formatMoney(getTotalNetContributionBalance) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="ibox col-md-12 border-0">
            <div v-if="em_reg_custom_list.length>0">
                <common-list  :pageurl="this.$api_url" :is_action="1" :is_pf="is_n_gf" :appended_column="em_reg_appended_column" :key="em_reg_list_key" :company_options="em_reg_company_options" :employees="em_reg_custom_list" :default_column="em_reg_default_column" :primary_key="em_reg_primary_key" v-on:childToParent="reg_edit"></common-list>
            </div>
            <div v-else>
                <div v-if="show_loader" class="list-no-data">
                    <span class="d-block text-center">Looking for relevant data..</span>
                    <img v-bind:src="this.$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="list-no-data">
                    Looks like there is no GF registrations to show.
                </div>
            </div>
        </div>
        
        <gf-profile-overview :pageurl="$api_url" :title="title" :employee_id="curr_emp_id" :show="show" :is_end="is_end"  :curr_gf_id="curr_gf_id" :key="overview_key" v-on:childToParent="overviewReturn"></gf-profile-overview>
    </div>
</template>

<script>
 export default {
    props: ['company_name'],
    data () {
        return {
            gf_summary: {
                total_active_employees: 0,
                total_gf_eligibile: 0,
                total_employee_awaiting_settlement: 0,
                total_gf_payable: 0,
                total_fund_contribution: 0,
                total_settlement_amount: 0,
                // total_reclaim_amount: 0,
            },

            total_net_contribution_balance: 0,
            current_date: null,
            em_reg_appended_column:[                 
                { value: "payable_amount", text: "Payable Amount",type: "amount"},
                // { value: "status", text: "Status",type: "text"},
            
            ], 
            is_n_gf:1,
            em_reg_list_key:0,
            em_reg_company_options:[],
            em_reg_custom_list:[],
            em_reg_default_column:['name','employee_code', 'date_of_joining'], /* Default Column List */
            details:[],
            em_reg_primary_key:'id',
            curr_emp_id: 0,
            is_end:0,
            title:'',
            show:0,
            show_loader: true,
        }
    },
    methods: {
        getGfSummary() {
            axios.get(this.$api_url+'/gf/summary')
            .then(response => {
                this.gf_summary = response.data;
            });
        },
        overviewReturn:function()
        {
            this.$validator.reset();
            // this.getLeaverEmployeeListData();
        },
        gfDetailsNew: function(employee_id)
        { 
            if(employee_id>0){
                let currentObj = this;
                
                let formData = new FormData();
                formData.append('employee_id', employee_id); 

                this.report_data = [];
                this.details = [];
                this.employee_info = [];
            
                axios.post(this.$api_url + '/gf/get-employee-data', formData)
                .then(function (response) 
                {
        
                    currentObj.details = response.data.data;
                    
                }.bind(this))
                .catch(function (error) 
                {
                    console.log(error);
                }); 

            }

            this.$bvModal.show('bv-modal-gf-details');
        },
        gfGetRegisteredEmployees: function()
        {
            this.min_date = this.curr_date;
            let currentObj = this;
            currentObj.show_loader = true;
            axios.get(this.$api_url+'/gf/employee/reglist' , {

            }).then(function(response){
                this.em_reg_custom_list = [];

                if (typeof response.data.employee_data !== 'undefined')
                {
                    this.em_reg_tmp_custom_list = response.data.employee_data;
                    this.em_tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));
                }
                if (typeof response.data.options !== 'undefined')
                {
                    this.em_reg_company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));
                }
                
                if(this.em_tmp_custom_list.length > 0 )
                {
                    this.em_tmp_custom_list.forEach(element => {
                        if(element.employee_id > 0)
                        {
                            
                            element.gf_total = this.formatMoney(element.gf_total);
                            let dop = []; 
                            let last_payslip =  element.last_payslip;
                            dop = dop.concat([{ label: 'Quick View' , value: 3 }]);
                            element.actions = dop;
                        }
                    });

                    this.em_reg_custom_list = this.em_tmp_custom_list;
    
                }
                else
                {
                    this.blankmsg = "No employee found as leaver";
                }
            
            
            this.em_reg_list_key = this.list_key + 1;
            currentObj.show_loader = false;
        
        }.bind(this)).catch(function (error){
            currentObj.show_loader = false;
            console.log(error);
            currentObj.serverError(error);
            
            });
        },
        reg_edit:function(data)
        {
            //console.log(data);

            this.curr_update_id = 0;
            this.curr_approve_date= 0;
            this.curr_update_employee= 0;

            if(data.selected.length > 0)
            {
                this.em_selected = data.selected;
            }
            else
            {
                this.em_selected = [];

            }
            if(data.id && data.action_id==3)
            {
                // var item  = this.em_reg_custom_list.find(item => item.id === data.id); 
                // this.gfDetailsNew(item.employee_id);

                let tmp_list  = this.em_tmp_custom_list;
                var item  = tmp_list.find(item => item.id === data.id); 
                
                this.curr_emp_id =item.employee_id;
                this.curr_emp_name=item.name;
                    this.show +=  1; 
                this.is_end =  0; 
                this.overview_key +=  1; 
                this.title =  'GF Employee Profile Overview'; 
            }

        },
    },
    created: function() {
        this.current_date = new Date().toISOString().split('T')[0];
        this.getGfSummary();
        this.gfGetRegisteredEmployees();
    },

    computed: {
        getTotalNetContributionBalance() {
            const fund = this.gf_summary.total_fund_contribution ?? 0;
            const settlement = this.gf_summary.total_settlement_amount ?? 0;
            // const reclaim = this.gf_summary.total_reclaim_amount ?? 0;

            // return fund + reclaim - settlement; //  Sifat: 07-07-2025 Check GF Module
            return fund - settlement; //  Sifat: 07-07-2025 Check GF Module
        }
    }
 }
</script>

<!-- End: Rejwan: 19-05-2025 GF Summary -->
